import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export const getLastProductWithBreadcrumbs = (products: Array<ProductVariantExtended>) => {

  const productsWithBreadcrumbs = products.filter((product) => product._breadcrumbs !== undefined);

  return productsWithBreadcrumbs[productsWithBreadcrumbs.length - 1];

};
